import { toUUID } from '../../util/transform';
import { YesNoOption } from '../global/YesNoOption.enum';
import type { IRiskInsuranceRequirementsApplicant } from './RiskInsuranceRequirementsApplicant.interface';

export default class RiskInsuranceRequirementsApplicant
  implements IRiskInsuranceRequirementsApplicant {
  idContact: string;
  modernInsurancePolicies: YesNoOption;
  excellentInsurancePolicies: YesNoOption;
  balanceBetweenSelfInsuringVersusTransferringRisk: YesNoOption;
  adequateInsuranceCover: YesNoOption;
  significantChangesToCircumstances: YesNoOption;

  static build = (data: IRiskInsuranceRequirementsApplicant) =>
    new RiskInsuranceRequirementsApplicant(data);

  static blank = (idContact) => new RiskInsuranceRequirementsApplicant({ idContact });

  /**
   * Constructor
   * @param {IRiskInsuranceRequirementsApplicant} data
   */
  constructor(data?: IRiskInsuranceRequirementsApplicant) {
    this.idContact = toUUID(data?.idContact);
    this.modernInsurancePolicies = YesNoOption.of(data?.modernInsurancePolicies?.name);
    this.excellentInsurancePolicies = YesNoOption.of(data?.excellentInsurancePolicies?.name);
    this.balanceBetweenSelfInsuringVersusTransferringRisk = YesNoOption.of(
      data?.balanceBetweenSelfInsuringVersusTransferringRisk?.name
    );
    this.adequateInsuranceCover = YesNoOption.of(data?.adequateInsuranceCover?.name);
    this.significantChangesToCircumstances = YesNoOption.of(
      data?.significantChangesToCircumstances?.name
    );
  }
}
